import { Box } from '@mui/material';

import useTokensBroker from '../../hooks/useTokensBroker';

export default function AuthAppIframe({
  defaultRedirectUrl,
}: {
  defaultRedirectUrl: string;
}) {
  useTokensBroker({ defaultRedirectUrl });

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
      }}
    >
      <iframe
        title="Auth App"
        id="auth-app"
        src={import.meta.env.VITE_AUTH_APP_URL}
        style={{ width: '100%', height: '100%', border: 0 }}
      />
    </Box>
  );
}
